export const education = [
  {
    id: 1,
    date: '2017-2018',
    course: 'INFORMATION SYSTEM TECHNOLOGY',
    uni: 'CITY UNIVERSITY LONDON',
    certificate: 'Post Graduate Certificate',
  },
  {
    id: 2,
    date: '2012-2016',
    course: 'COMPUTER SCIENCE',
    uni: 'UNIVERSITY OF HERTFORDSHIRE',
    certificate: 'Bachelors Degree',
  },
  {
    id: 3,
    date: '2011-2012',
    course: '',
    uni: 'READING COLLEGE',
    certificate: 'Further A Levels',
  },
  {
    id: 4,
    date: '2008-2011',
    course: '',
    uni: 'HIGHDOWN & SIXTH FORM CENTRE',
    certificate: 'A Levels',
  },
  {
    id: 5,
    date: '2006-2008',
    course: '',
    uni: 'PROSPECT COLLEGE OF TECHNOLOGY',
    certificate: 'GCSE',
  },
];
